<ng-container *ngIf="employee?.name">
	<div class="employee-infos-container">
		<img
			alt="avatar"
			[src]="
				employee?.profileImagePath || '/assets/images/logo/avatar-profile.png'
			"
			class="round avatar-img"
			height="40"
			width="40"
		/>
		<div class="employee-name">
			<span>{{ employee?.name }}</span>
			<span>MAT: {{ employee?.registration || "" }}</span>
		</div>
	</div>
</ng-container>
